import React, { useEffect, useState } from "react";
import { UserStats } from "./UserStats";
import { Stack, Typography } from "@mui/material";
import { getUserStats } from "../../../config/apisauce";
import { ApprovalProfileTable } from "../../../components/Table/ApprovalProfileTable";
import { IncompleteProfileTable } from "../../../components/Table/IncompleteProfileTable";
import { CollabRequestsTable } from "./../../../components/Table/CollabRequestsTable";

const AdminHomePage = () => {
  const [userStats, setUserStats] = useState([]);

  const fetchUserStats = async () => {
    const { ok, data } = await getUserStats();
    if (ok) {
      setUserStats(data);
    }
  };

  useEffect(() => {
    fetchUserStats();
  }, []);

  return (
    <Stack gap={2}>
      <Typography variant="h5" fontWeight={700} color="primary.main">Users</Typography>
      <UserStats userStats={userStats} />
      <ApprovalProfileTable minified={true} />
      <IncompleteProfileTable minified={true} />
      <CollabRequestsTable minified={true} />
    </Stack>
  );
};

export default AdminHomePage;
